export default "__VITE_ASSET__4lx4yfKY__"